<template>
    <v-dialog v-model="value" content-class="centered-dialog" :hide-overlay="hideOverlay" persistent>
        <v-container fill-height style="z-index: 10">
            <v-layout column justify-center align-center>
                <v-flex xs12>
                    <v-progress-circular
                        indeterminate
                        :size="70"
                        :width="7"
                        :color="progressColor"
                    ></v-progress-circular>
                </v-flex>
                <v-card flat class="transparent">
                    <v-card-text>
                        <w-span
                            v-if="message"
                            font-size="headline"
                            font-weight="medium"
                            :color="hideOverlay ? 'accent' : messageColor"
                        >
                            {{message}}
                        </w-span>
                    </v-card-text>
                </v-card>
            </v-layout>
        </v-container>
    </v-dialog>
</template>

<script>
    import WSpan from '../WSpan'

    /**
     * Displays a material loading spinner, centered across the entire page.
     */
    export default {
        name: 'WPageLoading',
        components: {
            WSpan
        },
        data: () => ({
            timeout: false
        }),
        props: {
            /**
             * Display the loading spinner.
             */
            value: {
                type: Boolean,
                default: false
            },
            /**
             * Message to display under the loading spinner. Works best with hideOverlay set to false (default).
             */
            message: {
                type: String,
                default: null
            },
            /**
             * Font color for message
             */
            messageColor: {
                type: String,
                default: 'light'
            },
            /**
             * Colour of the material loading spinner.
             */
            progressColor: {
                type: String,
                default: 'primary'
            },
            /**
             * Hide the overlap containing the loading spinner and message.
             */
            hideOverlay: {
                type: Boolean,
                default: false
            }
        },
        watch: {
            value (newVal, oldVal) {
                if (!newVal && oldVal) {
                    this.$emit('loading:complete')
                }
            }
        }
    }
</script>

<style lang="stylus">
    .v-dialog.centered-dialog
        box-shadow none
        border-radius 6px
        width auto
        color #9a9a9a
</style>
